export interface EdgeWhitespaceParts {
  leading: string;
  core: string;
  trailing: string;
}

/**
 * Splits a string into its leading whitespace, core content, and trailing
 * whitespace. A string made entirely of whitespace is treated as all-leading
 * (core and trailing are empty) so callers don't have to special-case it.
 */
export function splitEdgeWhitespace(text: string): EdgeWhitespaceParts {
  const match = /^(\s*)([\s\S]*?)(\s*)$/.exec(text);
  if (!match) {
    return { leading: '', core: text, trailing: '' };
  }
  const [, leading, core, trailing] = match;
  if (!core) {
    return { leading: text, core: '', trailing: '' };
  }
  return { leading: leading ?? '', core, trailing: trailing ?? '' };
}

/** Cheap check for UI affordances that don't need the full split (e.g. table row icons). */
export function hasEdgeWhitespace(text: string): boolean {
  return text.length > 0 && text.trim() !== text;
}
